// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createVendorPdfCatalogue = (client) => ({
    /**
     * `POST /vendor/pdf-catalogue/check-duplicates`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorPdfCatalogueCheckDuplicates
     * @source packages/medusa-plugin-pdf-catalogue-v2/src/api/vendor/pdf-catalogue/check-duplicates/route.ts
     */
    createCheckDuplicate: (body, query, headers) => client.fetch("/vendor/pdf-catalogue/check-duplicates", { method: "POST", body, query, headers }),
    /**
     * `GET /vendor/pdf-catalogue/history`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorPdfCatalogueHistoryRetrieve
     * @source packages/medusa-plugin-pdf-catalogue-v2/src/api/vendor/pdf-catalogue/history/route.ts
     */
    retrieveHistory: (query, headers) => client.fetch("/vendor/pdf-catalogue/history", { method: "GET", query, headers }),
    /**
     * `GET /vendor/pdf-catalogue/status/:jobId`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorPdfCatalogueStatusRetrieve
     * @source packages/medusa-plugin-pdf-catalogue-v2/src/api/vendor/pdf-catalogue/status/[jobId]/route.ts
     */
    retrieveStatus: (jobId, query, headers) => client.fetch(buildPath("/vendor/pdf-catalogue/status/:jobId", [jobId]), { method: "GET", query, headers }),
    /**
     * `POST /vendor/pdf-catalogue/image-import`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorPdfCatalogueImageImport
     * @source packages/medusa-plugin-pdf-catalogue-v2/src/api/vendor/pdf-catalogue/image-import/route.ts
     */
    updateImageImport: (body, query, headers) => client.fetch("/vendor/pdf-catalogue/image-import", { method: "POST", body, query, headers }),
    /**
     * `POST /vendor/pdf-catalogue/upload`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorPdfCatalogueUploadCreate
     * @source packages/medusa-plugin-pdf-catalogue-v2/src/api/vendor/pdf-catalogue/upload/route.ts
     */
    upload: (body, query, headers) => client.fetch("/vendor/pdf-catalogue/upload", { method: "POST", body, query, headers }),
});
//# sourceMappingURL=pdf-catalogue.js.map